'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/eye/EyeIcon.tsx
import { jsx } from "react/jsx-runtime";
var EyeIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "60",
      height: "46",
      viewBox: "0 0 60 46",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M30 0.831055C40.7493 0.831134 51.2206 7.25738 58.2133 19.5289C59.4395 21.6807 59.4395 24.3188 58.2133 26.4707C51.2206 38.7422 40.7493 45.1683 29.9999 45.1682C19.2506 45.1681 8.77933 38.7419 1.78658 26.4704C0.560397 24.3185 0.560396 21.6804 1.78659 19.5286C8.77934 7.25708 19.2506 0.830975 30 0.831055ZM19.9548 22.9997C19.9548 17.4519 24.4521 12.9545 29.9999 12.9545C35.5477 12.9545 40.0451 17.4519 40.0451 22.9997C40.0451 28.5475 35.5477 33.0449 29.9999 33.0449C24.4521 33.0449 19.9548 28.5475 19.9548 22.9997Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  EyeIcon
};
//# sourceMappingURL=chunk-AXBME4LJ.mjs.map